import { Banknote, Home, List, Users } from 'lucide-react';
import { Link, useLocation } from 'react-router';

import { cn } from '@/lib/utils';

const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: Home },
  { name: 'Listings', href: '/listings', icon: List },
  { name: 'Contractors', href: '/contractors', icon: Users },
  { name: 'Lenders', href: '/lenders', icon: Banknote },
];

/**
 * Sidebar navigation component matching Figma prototype
 */
export function Sidebar() {
  const location = useLocation();

  return (
    <div className="bg-white h-screen w-[260px] border-r border-[#e5e5e5] flex flex-col">
      <div className="px-[24px] py-[32px] border-b border-[#e5e5e5]">
        <h1 className="text-[#055135] text-[20px] font-semibold">TrueHaus Admin</h1>
      </div>

      <nav className="flex-1 px-[16px] py-[24px]">
        <div className="flex flex-col gap-[8px]">
          {navigation.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.href;

            return (
              <Link
                key={item.href}
                to={item.href}
                className={cn(
                  'flex items-center gap-[12px] px-[16px] py-[12px] rounded-[12px] transition-colors',
                  isActive ? 'bg-[#d5eee9] text-[#055135]' : 'text-[#8d8c8f] hover:bg-[#f5f5f5]'
                )}
              >
                <Icon size={20} />
                <span className="font-semibold text-[14px]">{item.name}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
